var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "91.75 80.02 91.75 67.53 81.59 73.39 81.59 85.89 91.75 80.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.75 47.98 81.21 41.89 64 51.83 46.79 41.89 36.25 47.98 36.25 59.05 53.75 69.16 53.75 90.13 64 96.05 74.25 90.13 74.25 69.16 91.75 59.05 91.75 47.98"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.35 48.89 109.35 37.82 98.81 31.73 88.55 37.65 99.09 43.74 99.09 54.81 109.35 48.89"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.91 54.81 28.91 43.74 39.45 37.65 29.19 31.73 18.65 37.82 18.65 48.89 28.91 54.81"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.25 80.02 46.41 85.89 46.41 73.39 36.25 67.53 36.25 80.02"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.25 98.61 64 104.53 53.75 98.61 53.75 110.45 64 116.37 74.25 110.45 74.25 98.61"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.87 37.65 64 31.95 54.13 37.65 64 43.35 73.87 37.65"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.09 63.29 99.09 84.26 81.59 94.37 81.59 106.21 109.35 90.18 109.35 57.37 99.09 63.29"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.41 94.37 28.91 84.26 28.91 63.29 18.65 57.37 18.65 90.18 46.41 106.21 46.41 94.37"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.79 33.41 64 23.48 81.21 33.41 91.47 27.49 64 11.63 36.53 27.49 46.79 33.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.5c10b50d235f0eee2320deb6e0c77b9b.svg";
export { ForwardRef as ReactComponent };